import { useState as S } from "react";
import q from "lodash.throttle";
import { useTranslation as x } from "../../../i18n.mjs";
import { useFileUploader as A } from "./use-file-uploader.mjs";
import { BadRequest as B } from "@systemeio/util";
import { FileUploaderItemStateEnum as n } from "../types/file-uploader-item-type.mjs";
import { executeWithConcurrencyLimit as V } from "../../../utils/execute-with-concurrency-limit.mjs";
import { areFilesDuplicate as k } from "../../../utils/are-files-duplicate.mjs";
import { generateUUID as J } from "../../../utils/generate-uuid.mjs";
const G = ({
  source: I,
  fileManagerApiType: W
}) => {
  const { t: F } = x(), { createFileUploader: w } = A(W), [d, l] = S([]), f = d.filter((e) => e.state === n.Waiting), h = () => J(), y = (e) => d.find((t) => t.uid === e), g = (e) => {
    let t = 0;
    const r = e.filter((o) => {
      const p = d.some((a) => k(a.file, o));
      return p && t++, !p;
    });
    return l((o) => [...r.map(
      (a) => ({
        uid: h(),
        file: a,
        state: n.Waiting
      })
    ), ...o]), t;
  }, E = (e) => {
    l((t) => t.filter((r) => r.state !== n.Waiting)), g(e);
  }, D = (e, t) => {
    l(
      (r) => r.map((o) => o.state === n.Waiting && o.uid === e ? {
        ...o,
        file: t
      } : o)
    );
  }, m = (e) => {
    l((t) => t.filter((r) => r.uid !== e));
  }, T = (e) => {
    const t = d.filter((r) => r.state === n.Waiting).find((r) => r.uid === e);
    t && m(t.uid);
  }, C = (e) => {
    const t = d.filter((r) => r.state === n.Uploading).find((r) => r.uid === e);
    t && (t.cancelUpload(), m(t.uid));
  }, U = async (e) => {
    var p;
    const t = q(({ progress: a }) => {
      l(
        (i) => i.map((s) => s.state === n.Uploading && s.uid === e ? {
          ...s,
          progress: a
        } : s)
      );
    }, 100), r = w(t);
    l(
      (a) => a.map((i) => i.uid === e ? {
        uid: i.uid,
        file: i.file,
        state: n.Uploading,
        progress: r.progress.getState().progress,
        cancelUpload: r.cancelUpload
      } : i)
    );
    const o = new Error(F("file_manager.error"));
    try {
      const a = (p = y(e)) == null ? void 0 : p.file;
      if (!a) throw o;
      const i = await r.upload({
        file: a,
        source: I
      });
      if (i)
        return l(
          (s) => s.map((u) => u.uid === e ? {
            uid: u.uid,
            file: u.file,
            fileInfo: i,
            state: n.Uploaded
          } : u)
        ), i;
    } catch (a) {
      const i = a instanceof Error ? a : o;
      let s;
      throw i instanceof B ? s = i.message || i.toErrorWithViolations().getJoinedViolationMessages() || o.message : s = i.message || o.message, l(
        (u) => u.map((c) => c.uid === e ? {
          uid: c.uid,
          file: c.file,
          state: n.Waiting,
          error: s
        } : c)
      ), i;
    }
  }, M = async (e = 10) => {
    const t = f.map((r) => () => U(r.uid));
    return await V(t, e);
  };
  return {
    items: d,
    waitingUploadItems: f,
    waitingUploadFiles: f.map((e) => e.file),
    uploadedFiles: d.filter((e) => e.state === n.Uploaded).map((e) => e.fileInfo),
    replaceWaitingUploadFiles: E,
    addFilesToWaitingUpload: g,
    replaceFileInWaitingUploadItem: D,
    deleteWaitingUploadItem: T,
    deleteUploadingItem: C,
    startUploading: U,
    startUploadingAll: M,
    clearAll: () => l([])
  };
};
export {
  G as useFileUploaderManager
};
